import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Paper,
  Card,
  CardContent
} from "@mui/material";
import EditFlatModal from "./EditFlatDetails";
import { calculateSqftPrice, calculateTotalPrice } from "../../Utils/pricecalculator";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
 
 
 
const ApartmentFlats = ({ flats = [],apartmentId }) => {
  const [search, setSearch] = useState("");
  const [selectedFlat, setSelectedFlat] = useState(null);
  const navigate = useNavigate();
 
 
  const filteredFlats = flats.filter(
    (flat) =>
      flat.FlatName?.toLowerCase().includes(search.toLowerCase()) ||
      flat.FlatType?.toLowerCase().includes(search.toLowerCase())
  );
 
 
  return (
    <Paper sx={{ p: 3, mb: 4 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Flats</Typography>
 
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={() =>
            navigate("/addFlat")
          }
 
        >
          Add Flat
        </Button>
      </Box>
 
 
      {/* Search */}
      <TextField
        fullWidth
        size="small"
        placeholder="Search flat by name or type"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 3 }}
      />
 
      {/* Flat Cards */}
      <Grid container spacing={2}>
        {filteredFlats.length === 0 && (
          <Grid item xs={12}>
            <Typography color="text.secondary" align="center">
              No flats found
            </Typography>
          </Grid>
        )}
 
        {filteredFlats.map((flat) => {
          const isPerSqft = flat.PriceType === "PerSqFt";
 
          const totalPrice = isPerSqft
            ? calculateTotalPrice(flat.Price, flat.SizeInSqFt)
            : flat.Price;
 
          const sqftPrice = isPerSqft
            ? flat.Price
            : calculateSqftPrice(flat.Price, flat.SizeInSqFt);
 
          return (
            <Grid item xs={12} sm={6} md={4} key={flat.Id}>
              <Card
                sx={{
                  cursor: "pointer",
                  height: "100%",
                  "&:hover": { boxShadow: 4 }
                }}
                onClick={() => setSelectedFlat(flat)}
              >
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600}>
                    {flat.FlatName}
                  </Typography>
 
                  <Typography variant="body2" color="text.secondary">
                    Type: {flat.FlatType}
                  </Typography>
 
                  <Typography variant="body2">
                    Size: {flat.SizeInSqFt} sq.ft
                  </Typography>
 
                  <Typography variant="body2">
                    Sq.ft Price: ₹{sqftPrice}
                  </Typography>
 
                  <Typography variant="body2" fontWeight={600}>
                    Total Price: ₹{totalPrice}
                  </Typography>
 
                  <Typography
                    variant="caption"
                    color={flat.Status === "Available" ? "green" : "red"}
                  >
                    {flat.Status}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
 
      {/* Edit Modal */}
      {selectedFlat && (
        <EditFlatModal
          open={Boolean(selectedFlat)}
          flat={selectedFlat}
          apartmentId={apartmentId}
          onClose={() => setSelectedFlat(null)}
        />
      )}
    </Paper>
  );
};
 
export default ApartmentFlats;